{
  "secret-nenshi": {
    "id": "secret-nenshi",
    "status": "released",
    "validAsOf": "2026-09-25",
    "keys": {
      "majority": "SEPARATIST",
      "minority": "FEDERALIST",
      "leader": "NENSHI"
    },
    "rules": {},
    "text": {
      "title": "Secret Nenshi",
      "editionName": "Alberta Edition",
      "tagline": "Alberta politics was already a social-deduction game.",
      "menuDescription": "Separatists, Federalists and one hidden former mayor decide Alberta's future. Five to ten players, one phone each.",
      "disclaimer": {
        "lead": "Secret Nenshi is an unofficial work of political satire.",
        "body": "Real public figures appear as fictional game characters. Hidden alliances, character assignments, game actions and fictional events do not imply undisclosed real-world cooperation, motives or conduct. Historical notes concerning real people should be based on publicly documented events or statements."
      },
      "about": [
        "Secret Nenshi is a hidden-role party game for 5–10 players in the same room, each using their own phone. It borrows the structure of a legislative social-deduction game and sets it in contemporary Alberta.",
        "No accounts. No sign-up. A game code, a name, and a room full of people who each believe they know what Albertans want."
      ],
      "openingHeading": "Alberta — 2026",
      "opening": [
        "The province is arguing about its future.",
        "Separatists are organizing. Federalists are organizing. Petitions have been signed. Politicians have taken positions. Lawyers have found work.",
        "And the citizens?",
        "!They’ll be asked eventually.",
        "Around this table are the people who intend to shape what happens next. Most want Alberta out.",
        "Hidden among them is an unlikely coalition determined to keep Alberta in Canada. New Democrats. Conservatives. Former Conservatives. People who would ordinarily prefer to argue with one another.",
        "And somewhere among them is:",
        "!Naheed Nenshi",
        "Pass five Separation Policies before the Federalists stop you.",
        "If the Federalists pass three policies:",
        "!Do not make Nenshi Premier."
      ],
      "factions": {
        "SEPARATIST": {
          "name": "Separatist",
          "plural": "Separatists",
          "accent": "#0b3a82",
          "accentInk": "#f6c13b"
        },
        "FEDERALIST": {
          "name": "Federalist",
          "plural": "Federalists",
          "accent": "#b3122e",
          "accentInk": "#ffffff"
        }
      },
      "leader": {
        "name": "Nenshi",
        "title": "Secret Nenshi",
        "accent": "#1d1c1a",
        "accentInk": "#f6c13b",
        "electedKicker": "And you made him Premier.",
        "momentumTitle": "The Federalists have momentum",
        "momentumText": "From this point forward, choosing the wrong Premier could end everything."
      },
      "offices": {
        "minister": "Minister",
        "premier": "Premier"
      },
      "policies": {
        "SEPARATION": {
          "name": "Separation Policy",
          "short": "Separation",
          "track": [
            "Organize",
            "Petition",
            "Referendum",
            "Negotiate",
            "Independence"
          ],
          "headlines": [
            "Independence Referendum",
            "Alberta Pension Plan",
            "Alberta Police Service",
            "Cease to Be Part of Canada",
            "Alberta Constitution",
            "Alberta Tax Collection"
          ]
        },
        "FEDERALIST": {
          "name": "Federalist Policy",
          "short": "Federalist",
          "track": [
            "Organize",
            "Verify",
            "Mobilize",
            "Challenge",
            "Block",
            "Remain"
          ],
          "headlines": [
            "Alberta Forever Canada",
            "Better Together",
            "Protect Confederation",
            "For Alberta For Canada",
            "National Unity",
            "Keep Canada Together"
          ]
        }
      },
      "powers": {
        "CAMPAIGN_RESEARCH": {
          "name": "Campaign Research",
          "short": "Research",
          "narrator": "Public statements are useful. Private information is better."
        },
        "INTERNAL_POLLING": {
          "name": "Internal Polling",
          "short": "Polling",
          "narrator": "Why ask everybody when 1,200 respondents will do?"
        },
        "UNITY_GOVERNMENT": {
          "name": "Unity Government",
          "short": "Unity",
          "narrator": "Principles have been temporarily rescheduled."
        },
        "COURT_CHALLENGE": {
          "name": "Court Challenge",
          "short": "Court",
          "narrator": "Democracy continues immediately after this brief legal proceeding."
        },
        "VETO": {
          "name": "Constitutional Veto",
          "short": "Veto",
          "narrator": "Apparently there are rules after all."
        }
      },
      "phases": {
        "confidenceVote": {
          "name": "Confidence vote",
          "confidence": "Confidence",
          "noConfidence": "No confidence",
          "narrator": "Democracy is important. Please indicate whether these two people may continue deciding things.",
          "after": "The politicians have voted."
        },
        "ministerBriefing": "Ministerial briefing",
        "premierDesk": "Premier’s desk",
        "policyEnacted": {
          "name": "Policy enacted",
          "narrator": "Albertans were consulted at some point."
        },
        "gridlock": {
          "name": "Legislative Gridlock",
          "short": "Gridlock",
          "title": "Albertans have had enough",
          "narrator": "The political class has failed to reach consensus.",
          "automatic": "Government has therefore occurred automatically."
        },
        "speech": {
          "name": "Speech from the Throne",
          "narrator": "The Government will now outline what it did, and why it was always the plan."
        },
        "questionPeriod": {
          "name": "Question Period",
          "narrator": "The Honourable Members may now ask questions. Answers are optional."
        },
        "waiting": "Democracy is important. Please wait while Cabinet decides what happens next.",
        "removed": {
          "title": "Campaign struck down",
          "narrator": "Democracy continues immediately after this brief legal proceeding."
        }
      },
      "wins": {
        "SEPARATION_POLICIES": {
          "headline": "Alberta leaves Canada",
          "winner": "Separatists win"
        },
        "FEDERALIST_POLICIES": {
          "headline": "Alberta remains in Canada",
          "winner": "Federalists win"
        },
        "NENSHI_BECOMES_PREMIER": {
          "headline": "Nenshi is Premier",
          "winner": "Federalists win",
          "line": "Confederation survives. Apparently this was the plan all along."
        },
        "NENSHI_REMOVED": {
          "headline": "Nenshi is out",
          "winner": "Separatists win"
        }
      },
      "gameOver": {
        "truth": "The truth comes out",
        "intro": "Every politician at this table had a public position. Now for the other one.",
        "cabinet": "The cabinet",
        "fiction": "Factions, alliances and everything that happened in this game are fiction. Real-world notes describe documented public positions; sources are on each card."
      },
      "lobby": {
        "gathered": "{count} Albertans have gathered to decide the future of four million others.",
        "quorum": "Share the game code. Democracy requires a quorum."
      }
    },
    "characters": [
      {
        "id": "naheed-nenshi",
        "displayName": "Naheed Nenshi",
        "faction": "FEDERALIST",
        "selectionPriority": 1,
        "specialRole": "NENSHI",
        "finalCardTitle": "SECRET NENSHI",
        "finalCardSubtitle": "Opposition Leader",
        "flavourText": "The least secret secret in Alberta politics.",
        "realWorldNote": "Naheed Nenshi is leader of the Alberta NDP and has publicly opposed Alberta separation, arguing that Alberta should remain in Canada.",
        "historicalBasis": [
          "Publicly opposed Alberta separatism and called for Alberta to remain in Canada.",
          "In 2026, challenged Alberta legislators to make their opposition to separatism explicit."
        ],
        "sources": [
          {
            "title": "Alberta separation petition quashed in favour of First Nations",
            "publisher": "CityNews Calgary",
            "publicationDate": "2026-05-13",
            "url": "https://calgary.citynews.ca/2026/05/13/judge-quashes-alberta-separation/",
            "accessedAt": "2026-09-25",
            "supports": "Reports Nenshi calling for the separation referendum to be ended."
          },
          {
            "title": "Extended: Opposition leader Naheed Nenshi responds to premier's separation referendum announcement",
            "publisher": "CTV News",
            "publicationDate": "2026-05-22",
            "url": "https://www.youtube.com/watch?v=YQtfDSvhfYg",
            "accessedAt": "2026-09-25",
            "supports": "Documents Nenshi's public response in support of remaining in Canada."
          }
        ],
        "verificationStatus": "VERIFIED",
        "validAsOf": "2026-09-25",
        "portrait": {
          "src": "/portraits/secret-nenshi/naheed-nenshi.webp",
          "alt": "Illustrated portrait of Naheed Nenshi.",
          "credit": "AI illustration based on reference photography",
          "licence": "Project-generated artwork; reference-image rights not conveyed"
        }
      },
      {
        "id": "danielle-smith",
        "displayName": "Danielle Smith",
        "faction": "FEDERALIST",
        "selectionPriority": 2,
        "finalCardTitle": "WITHIN CANADA",
        "finalCardSubtitle": "Premier of Alberta",
        "flavourText": "Sovereign, but check the fine print.",
        "realWorldNote": "Alberta Premier Danielle Smith has repeatedly stated that she does not support Alberta separating from Canada and has advocated a strong Alberta within a united Canada.",
        "historicalBasis": [
          "Publicly stated that she does not support Alberta separating from Canada.",
          "Advocated using provincial autonomy measures while remaining within Canada."
        ],
        "sources": [
          {
            "title": "Alberta Next: Albertans to decide path forward for the province",
            "publisher": "Government of Alberta",
            "url": "https://www.alberta.ca/article-alberta-next-albertans-to-decide-path-forward-for-the-province",
            "accessedAt": "2026-09-25",
            "supports": "Smith states that she does not support Alberta separating from Canada."
          }
        ],
        "verificationStatus": "VERIFIED",
        "validAsOf": "2026-09-25",
        "portrait": {
          "src": "/portraits/secret-nenshi/danielle-smith.webp",
          "alt": "Illustrated portrait of Danielle Smith.",
          "credit": "AI illustration based on reference photography",
          "licence": "Project-generated artwork; reference-image rights not conveyed"
        }
      },
      {
        "id": "thomas-lukaszuk",
        "displayName": "Thomas Lukaszuk",
        "faction": "FEDERALIST",
        "selectionPriority": 3,
        "finalCardTitle": "FOREVER CANADIAN",
        "finalCardSubtitle": "Petition Proponent",
        "flavourText": "He brought a petition to a petition fight.",
        "realWorldNote": "Former Alberta deputy premier Thomas Lukaszuk was the proponent of the Alberta Forever Canada citizen initiative and is a public advocate for Alberta remaining in Canada.",
        "historicalBasis": [
          "Served as proponent of the 2025 Alberta Forever Canada citizen initiative.",
          "Acts as primary contact for the registered Forever-Canadian Citizens Initiative Society."
        ],
        "sources": [
          {
            "title": "Citizen Initiative Petition — 2025 Alberta Forever Canada: Contribution Report",
            "publisher": "Elections Alberta",
            "url": "https://efpublic.elections.ab.ca/efOFSCIPReport.cfm?ACCOUNTID=9341&DOCSTATE=0",
            "accessedAt": "2026-09-25",
            "supports": "Lists Thomas Lukaszuk as proponent of Alberta Forever Canada."
          },
          {
            "title": "Referendum TPAs",
            "publisher": "Elections Alberta",
            "url": "https://www.elections.ab.ca/political-participants/third-party-advertisers/referendum-tpa/",
            "accessedAt": "2026-09-25",
            "supports": "Lists Lukaszuk as primary contact for Forever-Canadian Citizens Initiative Society."
          }
        ],
        "verificationStatus": "VERIFIED",
        "validAsOf": "2026-09-25",
        "portrait": {
          "src": "/portraits/secret-nenshi/thomas-lukaszuk.webp",
          "alt": "Illustrated portrait of Thomas Lukaszuk.",
          "credit": "AI illustration based on reference photography",
          "licence": "Project-generated artwork; reference-image rights not conveyed"
        }
      },
      {
        "id": "andrew-leach",
        "displayName": "Andrew Leach",
        "faction": "FEDERALIST",
        "selectionPriority": 4,
        "finalCardTitle": "LEAD. NOT LEAVE.",
        "finalCardSubtitle": "Economist",
        "flavourText": "There will be a spreadsheet.",
        "realWorldNote": "Andrew Leach, a University of Alberta economist and law professor, is an initial signatory of Lead. Not Leave., an initiative arguing that Alberta's future is strongest within a united Canada.",
        "historicalBasis": [
          "Initial signatory of Lead. Not Leave.",
          "Publicly associated with the initiative's case for Alberta remaining within Canada."
        ],
        "sources": [
          {
            "title": "Lead. Not Leave.",
            "publisher": "Lead. Not Leave.",
            "url": "https://www.leadnotleave.ca/",
            "accessedAt": "2026-09-25",
            "supports": "Lists Andrew Leach as an initial signatory and states the initiative supports Alberta remaining in Canada."
          },
          {
            "title": "Lead Not Leave advocates for a united Canada",
            "publisher": "The Gateway",
            "publicationDate": "2026-08-18",
            "url": "https://thegatewayonline.ca/2026/08/lead-not-leave-advocates-for-a-united-canada/",
            "accessedAt": "2026-09-25",
            "supports": "Identifies Leach as a member of the pro-unity policy initiative."
          }
        ],
        "verificationStatus": "VERIFIED",
        "validAsOf": "2026-09-25",
        "portrait": {
          "src": "/portraits/secret-nenshi/andrew-leach.webp",
          "alt": "Illustrated portrait of Andrew Leach.",
          "credit": "AI illustration based on reference photography",
          "licence": "Project-generated artwork; reference-image rights not conveyed"
        }
      },
      {
        "id": "mitch-sylvestre",
        "displayName": "Mitch Sylvestre",
        "faction": "SEPARATIST",
        "selectionPriority": 1,
        "finalCardTitle": "STAY FREE ALBERTA",
        "finalCardSubtitle": "Petition Proponent",
        "flavourText": "He brought the boxes.",
        "realWorldNote": "Mitch Sylvestre was the proponent of the 2026 citizen initiative seeking a referendum on Alberta becoming an independent state. Elections Alberta determined that the petition met the statutory signature requirement after verification.",
        "historicalBasis": [
          "Proponent of the 2026 Alberta independence citizen initiative petition.",
          "Public advocate for Alberta independence."
        ],
        "sources": [
          {
            "title": "Citizen Initiative Petition Verification Completed, Results Announced",
            "publisher": "Elections Alberta",
            "publicationDate": "2026-07-24",
            "url": "https://www.elections.ab.ca/resources/media/news-releases/ci-results-announced-sylvestre/",
            "accessedAt": "2026-09-25",
            "supports": "Identifies Sylvestre as proponent and reports that the statutory petition requirements were met."
          },
          {
            "title": "Mitch Sylvestre",
            "publisher": "MitchSylvestre.com",
            "url": "https://www.mitchsylvestre.com/",
            "accessedAt": "2026-09-25",
            "supports": "Describes Sylvestre's advocacy for an Alberta independence referendum."
          }
        ],
        "verificationStatus": "VERIFIED",
        "validAsOf": "2026-09-25",
        "portrait": {
          "src": "/portraits/secret-nenshi/mitch-sylvestre.webp",
          "alt": "Illustrated portrait of Mitch Sylvestre.",
          "credit": "AI illustration based on reference photography",
          "licence": "Project-generated artwork; reference-image rights not conveyed"
        }
      },
      {
        "id": "jeffrey-rath",
        "displayName": "Jeffrey Rath",
        "faction": "SEPARATIST",
        "selectionPriority": 2,
        "finalCardTitle": "COUNSEL FOR INDEPENDENCE",
        "finalCardSubtitle": "Constitutional Lawyer",
        "flavourText": "The cowboy hat has entered constitutional negotiations.",
        "realWorldNote": "Jeffrey Rath is a constitutional lawyer and General Counsel associated with the Alberta Prosperity Project who has publicly advocated Alberta independence and worked on the independence petition effort.",
        "historicalBasis": [
          "General Counsel for the Alberta Prosperity Project.",
          "Publicly advocated for an independent Alberta.",
          "Worked with Mitch Sylvestre on the Alberta independence petition process."
        ],
        "sources": [
          {
            "title": "Official Statement by Jeffrey Rath",
            "publisher": "Alberta Prosperity Project",
            "publicationDate": "2026-01-11",
            "url": "https://albertanation.com/articles/article-official-statement-by-jeffrey-rath-alberta-prosperity-project",
            "accessedAt": "2026-09-25",
            "supports": "Identifies Rath as General Counsel and connects him to the Alberta Independence petition process."
          },
          {
            "title": "Beiseker Let's Talk - Freedom & Prosperity Through Independence",
            "publisher": "Alberta Prosperity Project",
            "publicationDate": "2026-01-08",
            "url": "https://nb.albertaprosperity.com/let_s_talk_freedom_prosperity_through_sovereignty_20260108",
            "accessedAt": "2026-09-25",
            "supports": "Describes Rath as a supporter and leader advocating Alberta independence."
          }
        ],
        "verificationStatus": "VERIFIED",
        "validAsOf": "2026-09-25",
        "portrait": {
          "src": "/portraits/secret-nenshi/jeffrey-rath.webp",
          "alt": "Illustrated portrait of Jeffrey Rath wearing his characteristic cowboy hat.",
          "credit": "AI illustration based on reference photography",
          "licence": "Project-generated artwork; reference-image rights not conveyed"
        }
      },
      {
        "id": "david-parker",
        "displayName": "David Parker",
        "faction": "SEPARATIST",
        "selectionPriority": 3,
        "finalCardTitle": "TAKE BACK ALBERTA",
        "finalCardSubtitle": "Political Organizer",
        "flavourText": "Grassroots comes with a group chat.",
        "realWorldNote": "David Parker founded Take Back Alberta and has publicly advocated Alberta independence. He has participated publicly in the contemporary Alberta separation debate.",
        "historicalBasis": [
          "Founder of Take Back Alberta.",
          "Publicly identified as a pro-independence Alberta political organizer."
        ],
        "sources": [
          {
            "title": "About",
            "publisher": "Take Back Alberta",
            "url": "https://www.takingbackalberta.net/about",
            "accessedAt": "2026-09-25",
            "supports": "States that Take Back Alberta was founded by David Parker."
          },
          {
            "title": "Celebrities boosting Alberta separation as popularity grows",
            "publisher": "CityNews Edmonton",
            "publicationDate": "2026-04-10",
            "url": "https://edmonton.citynews.ca/2026/04/10/alberta-separation-celebrities/",
            "accessedAt": "2026-09-25",
            "supports": "Identifies Parker as a pro-independence Albertan and quotes him in the separation debate."
          }
        ],
        "verificationStatus": "VERIFIED",
        "validAsOf": "2026-09-25",
        "portrait": {
          "src": "/portraits/secret-nenshi/david-parker.webp",
          "alt": "Illustrated portrait of David Parker.",
          "credit": "AI illustration based on reference photography",
          "licence": "Project-generated artwork; reference-image rights not conveyed"
        }
      },
      {
        "id": "keith-wilson",
        "displayName": "Keith Wilson",
        "faction": "SEPARATIST",
        "selectionPriority": 4,
        "finalCardTitle": "LET ALBERTA DECIDE",
        "finalCardSubtitle": "Lawyer and Campaign Co-Lead",
        "flavourText": "Counsel has entered the referendum.",
        "realWorldNote": "Keith Wilson is a lawyer and public advocate for Alberta independence. He co-leads Let Alberta Decide, a registered referendum third-party advertiser.",
        "historicalBasis": [
          "Primary contact for the registered referendum advertiser Let Alberta Decide.",
          "Publicly identified by Let Alberta Decide as an Alberta independence advocate and campaign co-lead."
        ],
        "sources": [
          {
            "title": "Referendum TPAs",
            "publisher": "Elections Alberta",
            "url": "https://www.elections.ab.ca/political-participants/third-party-advertisers/referendum-tpa/",
            "accessedAt": "2026-09-25",
            "supports": "Lists Keith Wilson as primary contact for Let Alberta Decide."
          },
          {
            "title": "New Alberta Independence Organization to Launch 'Alberta's Done Waiting' Campaign",
            "publisher": "Let Alberta Decide / Newswire.ca",
            "publicationDate": "2026-06-17",
            "url": "https://www.newswire.ca/news-releases/media-advisory-new-alberta-independence-organization-to-launch-alberta-s-done-waiting-campaign-827491990.html",
            "accessedAt": "2026-09-25",
            "supports": "Identifies Wilson as an independence advocate and co-lead of Let Alberta Decide."
          }
        ],
        "verificationStatus": "VERIFIED",
        "validAsOf": "2026-09-25",
        "portrait": {
          "src": "/portraits/secret-nenshi/keith-wilson.webp",
          "alt": "Illustrated portrait of Keith Wilson.",
          "credit": "AI illustration based on reference photography",
          "licence": "Project-generated artwork; reference-image rights not conveyed"
        }
      },
      {
        "id": "tanya-clemens",
        "displayName": "Tanya Clemens",
        "faction": "SEPARATIST",
        "selectionPriority": 5,
        "finalCardTitle": "LET ALBERTA DECIDE",
        "finalCardSubtitle": "Farmer and Campaign Co-Lead",
        "flavourText": "The campaign has left the legislature and entered the field.",
        "realWorldNote": "Tanya Clemens is a southern Alberta farmer and former teacher who co-leads Let Alberta Decide and has publicly advocated Alberta independence and self-determination.",
        "historicalBasis": [
          "Co-leads Let Alberta Decide.",
          "Publicly identified as an advocate for Alberta independence and self-determination."
        ],
        "sources": [
          {
            "title": "New Alberta Independence Organization to Launch 'Alberta's Done Waiting' Campaign",
            "publisher": "Let Alberta Decide / Newswire.ca",
            "publicationDate": "2026-06-17",
            "url": "https://www.newswire.ca/news-releases/media-advisory-new-alberta-independence-organization-to-launch-alberta-s-done-waiting-campaign-827491990.html",
            "accessedAt": "2026-09-25",
            "supports": "Identifies Clemens as a farmer, former teacher, independence advocate, and co-lead of Let Alberta Decide."
          }
        ],
        "verificationStatus": "VERIFIED",
        "validAsOf": "2026-09-25",
        "portrait": {
          "src": "/portraits/secret-nenshi/tanya-clemens.webp",
          "alt": "Illustrated portrait of Tanya Clemens.",
          "credit": "AI illustration based on reference photography",
          "licence": "Project-generated artwork; reference-image rights not conveyed"
        }
      },
      {
        "id": "kathy-flett",
        "displayName": "Kathy Flett",
        "faction": "SEPARATIST",
        "selectionPriority": 6,
        "finalCardTitle": "WOMEN FOR INDEPENDENCE",
        "finalCardSubtitle": "Independence Organizer",
        "flavourText": "Coffee first. Confederation discussion second.",
        "realWorldNote": "Kathy Flett helps lead the Alberta Women's Independence Network and is the CFO of the registered referendum advertiser Alberta Women for Independence. The organization publicly campaigns for Alberta independence.",
        "historicalBasis": [
          "Helps lead the Alberta Women's Independence Network.",
          "CFO of Alberta Women for Independence, a registered referendum third-party advertiser.",
          "Associated with an organization explicitly campaigning for Alberta independence."
        ],
        "sources": [
          {
            "title": "About Us",
            "publisher": "Alberta Women's Independence Network",
            "url": "https://abwomensindependencenetwork.com/about",
            "accessedAt": "2026-09-25",
            "supports": "Names Flett as a leader and states the organization encourages Albertans to vote for independence."
          },
          {
            "title": "Referendum TPAs",
            "publisher": "Elections Alberta",
            "url": "https://www.elections.ab.ca/political-participants/third-party-advertisers/referendum-tpa/",
            "accessedAt": "2026-09-25",
            "supports": "Lists Kathy Flett as CFO of Alberta Women for Independence."
          }
        ],
        "verificationStatus": "VERIFIED",
        "validAsOf": "2026-09-25",
        "portrait": {
          "src": "/portraits/secret-nenshi/kathy-flett.webp",
          "alt": "Illustrated portrait of Kathy Flett.",
          "credit": "AI illustration based on reference photography",
          "licence": "Project-generated artwork; reference-image rights not conveyed"
        }
      },
      {
        "id": "cory-morgan",
        "displayName": "Cory Morgan",
        "faction": "SEPARATIST",
        "selectionPriority": 7,
        "finalCardTitle": "PATHWAY TO INDEPENDENCE",
        "finalCardSubtitle": "Columnist and Organizer",
        "flavourText": "He has been taking this exit ramp for a while.",
        "realWorldNote": "Cory Morgan is an Alberta columnist and political commentator with a long history of advocating Western and Alberta independence. He runs Pathway to Independence, a registered referendum third-party advertiser.",
        "historicalBasis": [
          "Primary contact for the registered referendum advertiser Pathway to Independence.",
          "Has publicly advocated Western and Alberta independence over many years."
        ],
        "sources": [
          {
            "title": "Referendum TPAs",
            "publisher": "Elections Alberta",
            "url": "https://www.elections.ab.ca/political-participants/third-party-advertisers/referendum-tpa/",
            "accessedAt": "2026-09-25",
            "supports": "Lists Cory Morgan as primary contact for Pathway to Independence."
          },
          {
            "title": "Charting a course to Western independence",
            "publisher": "Pathway to Independence / Cory Morgan",
            "publicationDate": "2021-09-22",
            "url": "https://corymorgan.com/book-release/",
            "accessedAt": "2026-09-25",
            "supports": "Morgan describes his history in independence politics and continued advocacy."
          },
          {
            "title": "Alberta separation billboard still standing in Taber",
            "publisher": "Global News",
            "publicationDate": "2026-06-15",
            "url": "https://globalnews.ca/news/11906800/alberta-separation-billboard-still-standing-taber/",
            "accessedAt": "2026-09-25",
            "supports": "Reports that Morgan paid for a pro-Alberta-separation billboard."
          }
        ],
        "verificationStatus": "VERIFIED",
        "validAsOf": "2026-09-25",
        "portrait": {
          "src": "/portraits/secret-nenshi/cory-morgan.webp",
          "alt": "Illustrated portrait of Cory Morgan.",
          "credit": "AI illustration based on reference photography",
          "licence": "Project-generated artwork; reference-image rights not conveyed"
        }
      }
    ]
  },
  "secret-poilievre": {
    "id": "secret-poilievre",
    "status": "released",
    "validAsOf": "2026-09-26",
    "keys": {
      "majority": "GOVERNMENT",
      "minority": "CONSERVATIVE",
      "leader": "POILIEVRE"
    },
    "rules": {},
    "text": {
      "title": "Secret Poilievre",
      "editionName": "Ottawa Edition",
      "tagline": "Everyone gets a vote. Some people get a caucus.",
      "menuDescription": "The Government, a Conservative coalition and one hidden Leader of the Opposition fight over Ottawa. Five to ten players, one phone each.",
      "disclaimer": {
        "lead": "Secret Poilievre is an unofficial work of political satire.",
        "body": "Real public figures appear as fictional game characters. A character's in-game faction is not a statement of party membership. Hidden alliances, character assignments, game actions and fictional events do not imply undisclosed real-world cooperation, motives or conduct. Notes concerning real people should be based on publicly documented events or statements."
      },
      "about": [
        "Secret Poilievre is the Ottawa Edition of Secret Nenshi: the same hidden-role party game for 5–10 players in the same room, each using their own phone, set in federal politics.",
        "No accounts. No sign-up. A game code, a name, and a room full of people who each believe they speak for Canadians."
      ],
      "openingHeading": "Ottawa — 2026",
      "opening": [
        "Canada has survived another election.",
        "Unfortunately, the politicians have survived too.",
        "The Government holds power. The Conservatives want it. The provinces want concessions. The Bloc wants Quebec to become a country.",
        "And everyone wants to be on television.",
        "Around this table are the people who will determine what happens next. Most are trying to keep the Government alive.",
        "Hidden among them is a Conservative coalition. They may be MPs. They may be premiers. They may be former prime ministers. They may spend most of their waking hours disagreeing with one another.",
        "But they share one objective.",
        "And somewhere among them is:",
        "!Pierre Poilievre",
        "Pass enough Government Policies to survive.",
        "But if the Conservatives gain momentum:",
        "!Do not make Poilievre Prime Minister."
      ],
      "factions": {
        "SEPARATIST": {
          "name": "Government",
          "plural": "Government",
          "accent": "#1e5b3f",
          "accentInk": "#f3efe4"
        },
        "FEDERALIST": {
          "name": "Conservative",
          "plural": "Conservatives",
          "accent": "#163e8c",
          "accentInk": "#ffffff"
        }
      },
      "leader": {
        "name": "Poilievre",
        "title": "Secret Poilievre",
        "accent": "#1d1c1a",
        "accentInk": "#f6c13b",
        "electedKicker": "And you made him Prime Minister.",
        "momentumTitle": "The Conservatives have momentum",
        "momentumText": "From this point forward, choosing the wrong Prime Minister could end everything."
      },
      "offices": {
        "minister": "Cabinet Minister",
        "premier": "Prime Minister"
      },
      "policies": {
        "SEPARATION": {
          "name": "Government Policy",
          "short": "Government",
          "track": [
            "Caucus",
            "Cabinet",
            "Confidence",
            "Legislate",
            "Government Holds"
          ],
          "headlines": [
            "Infrastructure Program",
            "Housing Program",
            "Defence Procurement",
            "Federal-Provincial Agreement",
            "Strategic Investment",
            "Budget Implementation"
          ]
        },
        "FEDERALIST": {
          "name": "Conservative Policy",
          "short": "Conservative",
          "track": [
            "Organize",
            "Oppose",
            "Gain Momentum",
            "Defeat Government",
            "Form Government",
            "Take Power"
          ],
          "headlines": [
            "Tax Cut",
            "Spending Reduction",
            "Resource Development",
            "Deregulation",
            "Criminal Justice Reform",
            "Housing Deregulation",
            "Government Restructuring"
          ]
        }
      },
      "powers": {
        "CAMPAIGN_RESEARCH": {
          "name": "Committee Hearing",
          "short": "Hearing",
          "narrator": "Ottawa's traditional method of discovering information several hours after everyone else already knew it."
        },
        "INTERNAL_POLLING": {
          "name": "Cabinet Briefing",
          "short": "Briefing",
          "narrator": "Classified information has been provided to exactly the person least likely to share it accurately."
        },
        "UNITY_GOVERNMENT": {
          "name": "Cabinet Shuffle",
          "short": "Shuffle",
          "narrator": "Nothing says stability like changing who's in charge."
        },
        "COURT_CHALLENGE": {
          "name": "Caucus Expulsion",
          "short": "Expulsion",
          "narrator": "The member will continue to serve Canadians by no longer participating."
        },
        "VETO": {
          "name": "Parliamentary Veto",
          "short": "Veto",
          "narrator": "Government has discovered an innovative legislative procedure. Doing neither thing."
        }
      },
      "phases": {
        "confidenceVote": {
          "name": "Confidence Vote",
          "confidence": "Confidence",
          "noConfidence": "No confidence",
          "narrator": "Your voice matters. Subject to caucus discipline and parliamentary procedure.",
          "after": "Confidence restored. At least until the next vote."
        },
        "ministerBriefing": "Cabinet Minister's briefing book",
        "premierDesk": "Prime Minister's desk",
        "policyEnacted": {
          "name": "Policy enacted",
          "narrator": "Canadians have spoken. Political professionals will now explain what they meant."
        },
        "gridlock": {
          "name": "Parliamentary Paralysis",
          "short": "Paralysis",
          "title": "Parliament is paralyzed",
          "narrator": "Canadians demanded action.",
          "automatic": "Parliament has therefore enacted something at random."
        },
        "speech": {
          "name": "Speech from the Throne",
          "narrator": "A deal has been reached. Nobody is entirely sure what was agreed to."
        },
        "questionPeriod": {
          "name": "Question Period",
          "narrator": "Parliament is working. Please lower your expectations accordingly."
        },
        "waiting": "Consultation complete. Thank you. Cabinet will take it from here.",
        "removed": {
          "title": "Expelled from caucus",
          "narrator": "The member will continue to serve Canadians by no longer participating."
        }
      },
      "wins": {
        "SEPARATION_POLICIES": {
          "headline": "The Government survives",
          "winner": "Government wins"
        },
        "FEDERALIST_POLICIES": {
          "headline": "The Conservatives take power",
          "winner": "Conservatives win"
        },
        "NENSHI_BECOMES_PREMIER": {
          "headline": "Poilievre is Prime Minister",
          "winner": "Conservatives win",
          "line": "The House has confidence in the new Prime Minister. Several members are still checking how."
        },
        "NENSHI_REMOVED": {
          "headline": "Poilievre is out",
          "winner": "Government wins"
        }
      },
      "gameOver": {
        "truth": "The truth comes out",
        "intro": "Every member at this table had a public position. Now for the other one.",
        "cabinet": "The House",
        "fiction": "Factions, alliances and everything that happened in this game are fiction; a character's faction is not a statement of party membership. Real-world notes describe documented public positions; sources are on each card."
      },
      "lobby": {
        "gathered": "{count} politicians have gathered to decide the future of forty million others.",
        "quorum": "Share the game code. The House requires a quorum."
      }
    },
    "characters": [
      {
        "id": "pierre-poilievre",
        "displayName": "Pierre Poilievre",
        "faction": "FEDERALIST",
        "selectionPriority": 1,
        "specialRole": "NENSHI",
        "finalCardTitle": "SECRET POILIEVRE",
        "finalCardSubtitle": "Conservative Leader",
        "flavourText": "You made him Prime Minister. That seems important.",
        "realWorldNote": "Pierre Poilievre is leader of the Conservative Party of Canada and Leader of the Official Opposition. He has led the federal Conservatives since September 2022.",
        "historicalBasis": [
          "Leader of the Conservative Party of Canada since September 2022.",
          "Leads the federal Conservative opposition to the Carney government.",
          "His hidden-leader role and any secret alliances depicted during play are fictional game mechanics."
        ],
        "sources": [
          {
            "title": "Pierre Poilievre",
            "publisher": "Conservative Party of Canada",
            "url": "https://www.conservative.ca/pierre-poilievre/",
            "accessedAt": "2026-09-26",
            "supports": "Identifies Poilievre as leader of the Conservative Party of Canada."
          },
          {
            "title": "Shadow Cabinet",
            "publisher": "Conservative Party of Canada",
            "url": "https://www.conservative.ca/team/shadow-cabinet/",
            "accessedAt": "2026-09-26",
            "supports": "Identifies Poilievre as Leader of the Official Opposition."
          }
        ],
        "verificationStatus": "VERIFIED",
        "validAsOf": "2026-09-26",
        "portrait": {
          "src": "/portraits/secret-poilievre/pierre-poilievre.webp",
          "alt": "Illustrated portrait of Pierre Poilievre.",
          "credit": "Project-generated artwork; reference-image rights not conveyed",
          "licence": "Project-generated artwork; reference-image rights not conveyed"
        }
      },
      {
        "id": "danielle-smith",
        "displayName": "Danielle Smith",
        "faction": "FEDERALIST",
        "selectionPriority": 2,
        "finalCardTitle": "THE WESTERN ALLY",
        "finalCardSubtitle": "Premier of Alberta",
        "flavourText": "Ottawa has been informed.",
        "realWorldNote": "Danielle Smith is Alberta's 19th Premier and leader of the governing United Conservative Party. At the January 2026 federal Conservative convention, she publicly expressed strong support for Pierre Poilievre's continued leadership.",
        "historicalBasis": [
          "Sworn in as Alberta's 19th Premier on October 11, 2022.",
          "Leader of Alberta's governing United Conservative Party.",
          "Publicly supported Poilievre at the federal Conservative convention in January 2026."
        ],
        "sources": [
          {
            "title": "Premier of Alberta",
            "publisher": "Government of Alberta",
            "url": "https://www.alberta.ca/premier",
            "accessedAt": "2026-09-26",
            "supports": "Identifies Smith as Alberta's 19th Premier and leader of the governing United Conservative Party."
          },
          {
            "title": "Alberta Premier Danielle Smith speaks at Conservative Party convention",
            "publisher": "Global News",
            "publicationDate": "2026-01-31",
            "url": "https://globalnews.ca/news/11645001/danielle-smith-conservative-party-convention-calgary/",
            "accessedAt": "2026-09-26",
            "supports": "Documents Smith publicly supporting Poilievre at the 2026 Conservative convention."
          }
        ],
        "verificationStatus": "VERIFIED",
        "validAsOf": "2026-09-26",
        "portrait": {
          "src": "/portraits/secret-poilievre/danielle-smith.webp",
          "alt": "Illustrated portrait of Danielle Smith.",
          "credit": "Project-generated artwork; reference-image rights not conveyed",
          "licence": "Project-generated artwork; reference-image rights not conveyed"
        }
      },
      {
        "id": "stephen-harper",
        "displayName": "Stephen Harper",
        "faction": "FEDERALIST",
        "selectionPriority": 3,
        "finalCardTitle": "THE OLD BOSS",
        "finalCardSubtitle": "Former Prime Minister",
        "flavourText": "Somewhere, a sweater vest has been activated.",
        "realWorldNote": "Stephen Harper served as Conservative Prime Minister of Canada from 2006 to 2015. Pierre Poilievre served as a minister in Harper's government, and Harper publicly endorsed Poilievre during the 2022 Conservative leadership contest.",
        "historicalBasis": [
          "Served as Conservative Prime Minister of Canada from 2006 to 2015.",
          "Poilievre served as a minister in Harper's government.",
          "Publicly endorsed Poilievre for Conservative leader in July 2022."
        ],
        "sources": [
          {
            "title": "Former Conservative PM Stephen Harper endorses Pierre Poilievre for party leader",
            "publisher": "CityNews / The Canadian Press",
            "publicationDate": "2022-07-25",
            "url": "https://toronto.citynews.ca/2022/07/25/former-conservative-pm-stephen-harper-endorses-pierre-poilievre-for-party-leader/",
            "accessedAt": "2026-09-26",
            "supports": "Documents Harper's endorsement of Poilievre and notes Poilievre's service as a minister under Harper."
          }
        ],
        "verificationStatus": "VERIFIED",
        "validAsOf": "2026-09-26",
        "portrait": {
          "src": "/portraits/secret-poilievre/stephen-harper.webp",
          "alt": "Illustrated portrait of Stephen Harper.",
          "credit": "Project-generated artwork; reference-image rights not conveyed",
          "licence": "Project-generated artwork; reference-image rights not conveyed"
        }
      },
      {
        "id": "preston-manning",
        "displayName": "Preston Manning",
        "faction": "FEDERALIST",
        "selectionPriority": 4,
        "finalCardTitle": "THE REFORMER",
        "finalCardSubtitle": "Former Reform Party Leader",
        "flavourText": "Before there was a Conservative coalition, there was a Reform plan.",
        "realWorldNote": "Preston Manning founded and led the Reform Party of Canada, a major predecessor in the political lineage that ultimately contributed to today's Conservative Party. His political career is closely associated with western Canadian reform politics and the Reform/Alliance tradition.",
        "historicalBasis": [
          "Founded and led the Reform Party of Canada.",
          "Reform and its successor, the Canadian Alliance, formed an important part of the political lineage of the modern Conservative Party.",
          "His CONSERVATIVE faction represents this documented political lineage; it does not assert a current hidden alliance with Poilievre."
        ],
        "sources": [
          {
            "title": "A call for rebalancing the federation",
            "publisher": "Policy Options / Institute for Research on Public Policy",
            "publicationDate": "2006-11-01",
            "url": "https://policyoptions.irpp.org/2006/11/a-call-for-rebalancing-the-federation-interview/",
            "accessedAt": "2026-09-26",
            "supports": "Identifies Manning as former Reform Party leader and discusses Reform's role in reconstructing the conservative movement."
          },
          {
            "title": "Leading the united Right – from the imperative of Conservative unity to the opportunity of Liberal scandals",
            "publisher": "Policy Options / Institute for Research on Public Policy",
            "publicationDate": "2004-03-01",
            "url": "https://policyoptions.irpp.org/fr/2004/03/leading-the-united-right-from-the-imperative-of-conservative-unity-to-the-opportunity-of-liberal-scandals/",
            "accessedAt": "2026-09-26",
            "supports": "Describes Manning's founding of the Reform Party and its subsequent transformation into the Canadian Alliance."
          }
        ],
        "verificationStatus": "VERIFIED",
        "validAsOf": "2026-09-26",
        "portrait": {
          "src": "/portraits/secret-poilievre/preston-manning.webp",
          "alt": "Illustrated portrait of Preston Manning.",
          "credit": "Project-generated artwork; reference-image rights not conveyed",
          "licence": "Project-generated artwork; reference-image rights not conveyed"
        }
      },
      {
        "id": "mark-carney",
        "displayName": "Mark Carney",
        "faction": "SEPARATIST",
        "selectionPriority": 1,
        "finalCardTitle": "TEAM CANADA",
        "finalCardSubtitle": "Prime Minister",
        "flavourText": "The central banker has acquired a confidence vote.",
        "realWorldNote": "Mark Carney is Canada's 24th Prime Minister. He became leader of the Liberal Party of Canada and was sworn in as Prime Minister in March 2025.",
        "historicalBasis": [
          "Became leader of the Liberal Party of Canada and was sworn in as Prime Minister in March 2025.",
          "Leads the federal government represented by the GOVERNMENT faction in this edition."
        ],
        "sources": [
          {
            "title": "About",
            "publisher": "Prime Minister of Canada",
            "url": "https://www.pm.gc.ca/en/about",
            "accessedAt": "2026-09-26",
            "supports": "Identifies Carney as Canada's 24th Prime Minister and states that he became Liberal leader and was sworn in during March 2025."
          },
          {
            "title": "Cabinet",
            "publisher": "Prime Minister of Canada",
            "url": "https://www.pm.gc.ca/en/cabinet",
            "accessedAt": "2026-09-26",
            "supports": "Lists Carney as Prime Minister of Canada."
          }
        ],
        "verificationStatus": "VERIFIED",
        "validAsOf": "2026-09-26",
        "portrait": {
          "src": "/portraits/secret-poilievre/mark-carney.webp",
          "alt": "Illustrated portrait of Mark Carney.",
          "credit": "Project-generated artwork; reference-image rights not conveyed",
          "licence": "Project-generated artwork; reference-image rights not conveyed"
        }
      },
      {
        "id": "doug-ford",
        "displayName": "Doug Ford",
        "faction": "SEPARATIST",
        "selectionPriority": 2,
        "finalCardTitle": "THE TURNCOAT",
        "finalCardSubtitle": "Premier of Ontario",
        "flavourText": "No, seriously. Check the faction again.",
        "realWorldNote": "Ontario Progressive Conservative Premier Doug Ford has publicly emphasized cooperation with Prime Minister Mark Carney despite disagreements between their governments. In January 2026, Ford said he and Carney agreed on \"99 per cent\" of things and described their discussion as being about \"Team Canada.\"",
        "historicalBasis": [
          "Premier of Ontario and leader of Ontario's Progressive Conservative government.",
          "Publicly emphasized cooperation and a Team Canada relationship with Carney in January 2026.",
          "His GOVERNMENT faction is a satirical game abstraction of documented political cooperation, not a claim that Ford is a Liberal."
        ],
        "sources": [
          {
            "title": "Ford and Carney agree on ‘99%’ of issues despite Chinese EV spat",
            "publisher": "Global News",
            "publicationDate": "2026-01-26",
            "url": "https://globalnews.ca/news/11637911/ontario-doug-ford-meet-federal-evs/",
            "accessedAt": "2026-09-26",
            "supports": "Reports Ford saying his meeting with Carney was about Team Canada and that they agreed on 99 per cent of the same things."
          }
        ],
        "verificationStatus": "VERIFIED",
        "validAsOf": "2026-09-26",
        "portrait": {
          "src": "/portraits/secret-poilievre/doug-ford.webp",
          "alt": "Illustrated portrait of Doug Ford.",
          "credit": "Project-generated artwork; reference-image rights not conveyed",
          "licence": "Project-generated artwork; reference-image rights not conveyed"
        }
      },
      {
        "id": "chrystia-freeland",
        "displayName": "Chrystia Freeland",
        "faction": "SEPARATIST",
        "selectionPriority": 3,
        "finalCardTitle": "THE FORMER DEPUTY",
        "finalCardSubtitle": "Former Deputy Prime Minister",
        "flavourText": "Ottawa experience: extensive.",
        "realWorldNote": "Chrystia Freeland served as Canada's Deputy Prime Minister from November 2019 to December 2024 and as Minister of Finance from August 2020 to December 2024. She subsequently served as Minister of Transport and Internal Trade in 2025.",
        "historicalBasis": [
          "Served as Deputy Prime Minister from 2019 to 2024.",
          "Served as Minister of Finance from 2020 to 2024.",
          "Her GOVERNMENT faction reflects her documented senior service in recent Liberal federal governments."
        ],
        "sources": [
          {
            "title": "Roles - Hon. Chrystia Freeland - Current and Past",
            "publisher": "House of Commons of Canada",
            "url": "https://www.ourcommons.ca/members/en/chrystia-freeland%2884665%29/roles",
            "accessedAt": "2026-09-26",
            "supports": "Documents Freeland's terms as Deputy Prime Minister, Minister of Finance, and Minister of Transport and Internal Trade."
          }
        ],
        "verificationStatus": "VERIFIED",
        "validAsOf": "2026-09-26",
        "portrait": {
          "src": "/portraits/secret-poilievre/chrystia-freeland.webp",
          "alt": "Illustrated portrait of Chrystia Freeland.",
          "credit": "Project-generated artwork; reference-image rights not conveyed",
          "licence": "Project-generated artwork; reference-image rights not conveyed"
        }
      },
      {
        "id": "yves-francois-blanchet",
        "displayName": "Yves-François Blanchet",
        "faction": "SEPARATIST",
        "selectionPriority": 4,
        "finalCardTitle": "THE SOVEREIGNIST",
        "finalCardSubtitle": "Bloc Québécois Leader",
        "flavourText": "Saving Ottawa for reasons that will require a flowchart.",
        "realWorldNote": "Yves-François Blanchet is leader of the Bloc Québécois and MP for Beloeil—Chambly. The Bloc describes itself as an independence movement that promotes Quebec sovereignty while representing Quebec's interests in Canada's Parliament.",
        "historicalBasis": [
          "Leader of the Bloc Québécois since 2019.",
          "Public advocate of Quebec sovereignty.",
          "His GOVERNMENT faction is deliberately paradoxical game fiction and does not imply support for Canadian federalism, the Liberal Party, or the Carney government."
        ],
        "sources": [
          {
            "title": "Yves-François Blanchet",
            "publisher": "Bloc Québécois",
            "url": "https://www.blocquebecois.org/le-chef/",
            "accessedAt": "2026-09-26",
            "supports": "Identifies Blanchet as Bloc leader and describes the Bloc as an independence party promoting Quebec sovereignty and Quebec interests in Parliament."
          },
          {
            "title": "Projet de loi du Bloc Québécois pour abroger la Loi sur la clarté référendaire : Respectons la démocratie",
            "publisher": "Bloc Québécois",
            "publicationDate": "2026-06-02",
            "url": "https://www.blocquebecois.org/projet-de-loi-du-bloc-quebecois-pour-abroger-la-loi-sur-la-clarte-referendaire-respectons-la-democratie/",
            "accessedAt": "2026-09-26",
            "supports": "Documents Blanchet's continuing advocacy for Quebec's right to determine its political future."
          }
        ],
        "verificationStatus": "VERIFIED",
        "validAsOf": "2026-09-26",
        "portrait": {
          "src": "/portraits/secret-poilievre/yves-francois-blanchet.webp",
          "alt": "Illustrated portrait of Yves-François Blanchet.",
          "credit": "Project-generated artwork; reference-image rights not conveyed",
          "licence": "Project-generated artwork; reference-image rights not conveyed"
        }
      },
      {
        "id": "avi-lewis",
        "displayName": "Avi Lewis",
        "faction": "SEPARATIST",
        "selectionPriority": 5,
        "finalCardTitle": "THE REBUILDER",
        "finalCardSubtitle": "NDP Leader",
        "flavourText": "Good news: you're the leader. Bad news: have you seen the caucus?",
        "realWorldNote": "Avi Lewis was elected leader of Canada's NDP on March 29, 2026, winning 56% of the first-ballot vote. After his election, Lewis described his new senior team as ready to begin rebuilding the party.",
        "historicalBasis": [
          "Elected leader of Canada's NDP on March 29, 2026 with 56% of the first-ballot vote.",
          "Publicly described his post-leadership-election task in terms of rebuilding the party.",
          "His GOVERNMENT faction is a satirical game abstraction and does not imply membership in or support for the Liberal Party."
        ],
        "sources": [
          {
            "title": "Avi Lewis elected Leader of NDP",
            "publisher": "Canada's NDP",
            "publicationDate": "2026-03-29",
            "url": "https://clarehacksel.ndp.ca/news/avi-lewis-elected-leader-ndp",
            "accessedAt": "2026-09-26",
            "supports": "Documents Lewis's election as NDP leader with 56% of the first-ballot vote."
          },
          {
            "title": "NDP leader Avi Lewis announces details of senior team",
            "publisher": "Canada's NDP",
            "publicationDate": "2026-03-30",
            "url": "https://www.ndp.ca/news/ndp-leader-avi-lewis-announces-details-senior-team",
            "accessedAt": "2026-09-26",
            "supports": "Documents Lewis describing his new team as ready to start rebuilding the party from day one."
          }
        ],
        "verificationStatus": "VERIFIED",
        "validAsOf": "2026-09-26",
        "portrait": {
          "src": "/portraits/secret-poilievre/avi-lewis.webp",
          "alt": "Illustrated portrait of Avi Lewis.",
          "credit": "AI illustration based on reference photography",
          "licence": "Project-generated artwork; reference-image rights not conveyed"
        }
      },
      {
        "id": "elizabeth-may",
        "displayName": "Elizabeth May",
        "faction": "SEPARATIST",
        "selectionPriority": 6,
        "finalCardTitle": "THE WILDCARD",
        "finalCardSubtitle": "Green Party Leader",
        "flavourText": "Nobody knows what she's about to say. This includes Elizabeth May.",
        "realWorldNote": "Elizabeth May is leader of the Green Party of Canada and MP for Saanich—Gulf Islands. She announced in August 2025 that she would step down once a successor could be elected; the party launched its 2026 leadership race in June, with results scheduled for November.",
        "historicalBasis": [
          "Current Green Party leader while the party conducts a 2026 race to choose her successor.",
          "Long-serving federal Green politician and MP for Saanich—Gulf Islands.",
          "Her GOVERNMENT faction is a satirical game abstraction and does not imply membership in or support for the Liberal Party."
        ],
        "sources": [
          {
            "title": "Green Party of Canada launches leadership race",
            "publisher": "Green Party of Canada",
            "publicationDate": "2026-06-11",
            "url": "https://www.greenparty.ca/en/news/green-party-of-canada-launches-leadership-race",
            "accessedAt": "2026-09-26",
            "supports": "Documents May's continuing leadership, her plan to step down after a successor is elected, and the launch of the 2026 leadership race."
          },
          {
            "title": "Our Team",
            "publisher": "Green Party of Canada",
            "url": "https://www.greenparty.ca/en/our-team",
            "accessedAt": "2026-09-26",
            "supports": "Identifies May as Green Party leader and MP for Saanich—Gulf Islands."
          }
        ],
        "verificationStatus": "VERIFIED",
        "validAsOf": "2026-09-26",
        "portrait": {
          "src": "/portraits/secret-poilievre/elizabeth-may.webp",
          "alt": "Illustrated portrait of Elizabeth May.",
          "credit": "AI illustration based on reference photography",
          "licence": "Project-generated artwork; reference-image rights not conveyed"
        }
      }
    ]
  }
}
